import React, { Component } from 'react' 
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom' 
import Modal from 'react-modal';

import config from 'util/config.js'
import { Button, ButtonLink } from 'components/Buttons'
import { getSelected } from 'state/customize/selectors'
import * as actions from 'ducks/modules/customize'


export class DeepLink extends Component {
  
  constructor() {
    super()
    this.state = { 
      ready: null,
    }
  }

  componentWillMount() {
    this.setState({ready: false});
    this.props.startLoad();
    if(!!this.props.instanceId) {
      this.props.loadInspirationInstance(this.props.instanceId);
    } else if(!!this.props.savedInstanceId) {
      this.props.loadSavedInstance(this.props.savedInstanceId);
    } else if(!!this.props.orderItemId) {
      this.props.loadOrderInstance(this.props.orderItemId);
    } 
  }

  componentWillReceiveProps(nextProps) {
      this.setState({
        ready: !nextProps.loading,
      });
  }

  render() {
    if (!this.state.ready)
      return <div>Loading...</div>
    else if (!this.props.instance)
      return <Modal className="customizer modal-popup" overlayClassName="modal-overlay" isOpen={true} contentLabel="Not Authorized" >
        <Link className="close-modal" to='/findputter'>X</Link>
        <div>
          <div className="modal-header">Not Found</div>
          <div className="modal-content">
            This putter was not found.
                  {(this.props.instanceIntent === "updateOrder") ? "If you recently placed this order, " +
              "please allow 15 minutes for your order to be processed in our system before you edit it. " +
              "If after 15 minutes you still cannot view or edit this putter, call Customer Service." : ""}
          </div>
          <div className="color-replace-buttons apply-finish-buttons">
            <ButtonLink to='/findputter'>Start a new design</ButtonLink>
          </div>
        </div>
              </Modal>
    else if (!this.props.authorized)
      return <Modal className="customizer modal-popup" overlayClassName="modal-overlay" isOpen={true} contentLabel="Not Authorized" > 
          <div>
            <Link className="close-modal" to='/findputter'>X</Link>
            {(!window._SC_IS_LOGGED_IN && 
              <div>
                <div className="modal-header">Not Logged In</div> 
                <div className="modal-content"> You must be logged in to edit a putter.</div>
              </div>
            )||(
              <div>
                <div className="modal-header">Not Authorized</div> 
                <div className="modal-content"> We’re sorry. You cannot edit this putter. 
                {(this.props.instanceIntent === "updateOrder") ? "Either t" : "T"}his putter is not associated with your account 
                {(this.props.instanceIntent === "updateOrder") ? " or your putter has already been received by the Scotty Cameron Custom Shop and is currently underway." :"."}
                </div> 
              </div> 
            )} 
            <div className="color-replace-buttons apply-finish-buttons">
              <Button href={config.loginUrl + "?r=" + window.location.pathname}>Log In </Button>
              <Button onClick={ ()=> this.props.setInstanceIntent('') } >View a New Copy of this design</Button> 
              <ButtonLink to='/findputter'>Start a new design</ButtonLink>
            </div>
          </div>
        </Modal>
    else 
      return <Redirect to={"/customize/" + this.props.putterId + "/finish"} />
  }
}
/*

*/

DeepLink.defaultProps = {
};

const mapStateToProps = (state, ownProps) => {
  var instanceIntent = state.customize.instanceIntent;
  var instance = state.customize.instance;
  var authorized = instance && (!instanceIntent ||
    (instanceIntent === "updateSaved" && instance.userCanUpdate) ||
    (instanceIntent === "updateOrder" && instance.userCanUpdateOrder)
  )

  return { 
    loading : state.customize.loading,
    instanceIntent,
    instance,
    authorized,
    putter : state.customize.putter,
    putterId: (state.customize.instance) ? getSelected(state.customize, 'model') : 0,
    instanceId: ownProps.match.params.instanceId,
    savedInstanceId: ownProps.match.params.savedInstanceId,
    orderItemId: ownProps.match.params.orderItemId,
  }
}

const mapDispatchToProps = {
  startLoad: actions.startLoad,
  loadPutter: actions.loadPutter,
  setInstanceIntent: actions.setInstanceIntent,
  loadInspirationInstance: actions.loadInspirationInstance,
  loadSavedInstance: actions.loadSavedInstance,
  loadOrderInstance: actions.loadOrderInstance,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeepLink); 